import { AnyObject } from "final-form";
import i18next from "config/i18next";
import { ValidateTimeIntervalParamsType } from "utils/types";
import {
  validateHourDifference,
  validateTimeInterval,
} from "utils/validations";
import * as yup from "yup";

const requiredMessage = i18next.t("validations:required");

const validationHourParams = {
  minDifference: 30,
  minMessage: i18next.t("slotCreation:minTimeDifferenceError"),
  maxDifference: 360,
  maxMessage: i18next.t("slotCreation:maxTimeDifferenceError"),
  field: "slotTime.end",
};

const validationTimeIntervalParams: ValidateTimeIntervalParamsType = {
  message: i18next.t("slotCreation:timeIntervalError"),
  field: "",
  interval: 15,
};

const validateSlotTime = (context: yup.TestContext<AnyObject>) =>
  validateHourDifference(context, validationHourParams);

const validateSlotIntervalTime = (
  value: string,
  context: yup.TestContext<AnyObject>,
  field: string
) =>
  validateTimeInterval(value, context, {
    ...validationTimeIntervalParams,
    field,
  });

const slotTime = yup.object({
  initial: yup
    .string()
    .test("timeValidation", (value, context) => validateSlotTime(context))
    .test("intervalValidation", (val, ctx) =>
      validateSlotIntervalTime(val || "", ctx, "slotTime.initial")
    )
    .required(requiredMessage),
  end: yup
    .string()
    .test("timeValidation", (value, context) => validateSlotTime(context))
    .test("intervalValidation", (val, ctx) =>
      validateSlotIntervalTime(val || "", ctx, "slotTime.end")
    )
    .required(requiredMessage),
});

export const validationSchema = yup.object({
  region: yup.object().required(requiredMessage),
  workzone: yup.object().required(requiredMessage),
  slotTime: slotTime,
  frequency: yup.object().required(),
});
